export default class FinancialProductManagementService {
  constructor($http, appConfig) {
    "ngInject";

    this.$http = $http;
    this.appConfig = appConfig;
  }

  addFinancialProduct(entityId, extraName, reportable, defaultPrice) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/financialproduct/add/${entityId}/${extraName}/${reportable}/${defaultPrice}`);
  }

  editFinancialProduct(entityId, financialProductId, extraName, reportable, defaultPrice) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/financialproduct/edit/${entityId}/${financialProductId}/${extraName}/${reportable}/${defaultPrice}`);
  }

  removeFinancialProduct(entityId, financialProductId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/financialproduct/remove/${entityId}/${financialProductId}`);
  }  
}



// WEBPACK FOOTER //
// ./client/app/components/admin/financialProductManagement/FinancialProductManagement.Service.js